import { Component, inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { IonIcon, IonTabBar, IonTabButton, IonTabs, IonBadge, ViewWillEnter } from '@ionic/angular/standalone';
import { addIcons } from "ionicons";
import { bagHandle, bus, notifications, trophy } from "ionicons/icons";
import { CommonModule } from '@angular/common';
import { AuthService } from '../auth.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';
import { MessagingService } from '../messaging.service';


@Component({
    selector: 'app-tabs',
    templateUrl: 'tabs.page.html',
    styleUrls: ['tabs.page.scss'],
    imports: [IonBadge,
        CommonModule,
        IonTabs,
        IonTabBar,
        IonTabButton,
        IonIcon
    ],
    standalone: true
})
export class TabsPage implements OnInit, OnDestroy, ViewWillEnter {


    auth = inject(AuthService)
    api = inject(ApiService)
    messaging = inject(MessagingService)

    showTransportation = false
    authSub: Subscription
    unreadSub: Subscription

    bookingBadgeCount = 0
    notificationsBadgeCount = 0

    constructor(private zone: NgZone) {
        addIcons({trophy,bus,bagHandle,notifications});
    }
    async ionViewWillEnter() {
        console.log("ionViewWillEnter tabs")
    }

    ngOnDestroy() {
        if (this.authSub) {
            this.authSub.unsubscribe()
        }

        if(this.unreadSub) {
            this.unreadSub.unsubscribe()
        }
    }

    ngOnInit() {

        this.unreadSub = this.messaging.unreadBadgeStateChange$.subscribe((ns) => {
            
            this.zone.run(() => {
                console.log("unreadBadgeStateChange", ns)
                this.notificationsBadgeCount = ns ? ns : 0
            })
            
        })

        this.authSub = this.auth.authStateChange$.subscribe(async (user) => {
            if (user && user.selectedGroup.transportation_active) {
                this.showTransportation = true
            } else {
                this.showTransportation = false
            }
        })
    }

    onTabChange(e: { tab: string; }) {
        console.log("Tab changed:",e.tab)
        if(e.tab === "notifications") {
            //this.notificationsBadgeCount = 0
            // this.changeDetector.detectChanges()
        }
        
        // if(e.tab === "booking") {
        //     this.api.bookings().then((res) => {
        //         this.bookingBadgeCount = res.services.length - this.bookingBadgeCount
        //     })
        // }
    }

}
